<ng-container *transloco="let t; read: 'partials.onlinetests'">
  <div *ngIf="ac !== null && onlinetests.length > 0 && (isMod || isCandidate || (isObserver && showForObservers))">
    <h2 class="label" [class.opened]="isOpen === true">
      <span class="pointer" (click)="toggleContainer()">{{ t('online_tests') }}</span>
      <button *ngIf="isOpen !== true" pButton type="button" class="p-button-sm p-button-secondary p-button-text toggle" (click)="toggleContainer()" icon="pi pi-chevron-down" pTooltip="{{ t('expand') }}" tooltipPosition="bottom"></button>
      <button *ngIf="isOpen === true" pButton type="button" class="p-button-sm p-button-secondary p-button-text toggle" (click)="toggleContainer()" icon="pi pi-chevron-up" pTooltip="{{ t('collapse') }}" tooltipPosition="bottom"></button>
    </h2>
    <ng-container *ngIf="isOpen === true">
      <ul>
        <li *ngFor="let onlinetest of onlinetests; index as i">
          <!-- INACTIVE -->
          <ng-container *ngIf="onlinetest.visible !== true">
            <div class="p-grid p-nogutter inactive">
              <div class="p-col-fixed icon"><fa-icon [icon]="faHourglassHalf" class="p-mr-2"></fa-icon></div>
              <div class="p-col">
                {{onlinetest.fullname}}<br>
                <span class="small">{{ t((isMod || isObserver) ? 'unlocked_for_candidate_at' : 'unlocked_at') }} {{onlinetest.visible_at | amLocal | amDateFormat: 'DD.MM.YYYY' }}</span>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="onlinetest.visible === true">
            <div class="p-grid p-nogutter">
              <div class="p-col-fixed icon-number"><span>{{i + 1}}</span></div>
              <div class="p-col">
                <!-- MODERATOR -->
                <ng-container *ngIf="isMod || isObserver">
                  <a (click)="openOnlinetest(onlinetest)" (keyup.enter)="openOnlinetest(onlinetest)" role="link" tabindex="0">{{onlinetest.fullname}}</a>
                  <ng-container *ngFor="let candidate of onlinetest.candidates">
                    <p class="subinfo">
                      <span *ngIf="onlinetest.candidates.length > 1">{{ getCandidateName(candidate) }}: </span>
                      <span *ngIf="candidate.hasReports !== true && !ac.isRunning()" class="disabled">{{ t('no_report') }}</span>
                      <span *ngIf="candidate.hasReports === true"><strong>{{ t('report_available') }} <fa-icon [icon]="faCheck"></fa-icon></strong></span>
                    </p>
                  </ng-container>
                </ng-container>
                <!-- CANDIDATE -->
                <ng-container *ngIf="isCandidate">
                  <ng-container *ngFor="let candidate of onlinetest.candidates">
                    <ng-container *ngIf="isMy(candidate.hashed_id)">
                      <ng-container  *ngIf="candidate.status !== 'finished' && candidate.status !== 'result'">
                        <a (click)="openOnlinetest(onlinetest)" (keyup.enter)="openOnlinetest(onlinetest)" role="link" tabindex="0">{{onlinetest.fullname}}</a><span class="p-ml-1 cursor-pointer"><fa-icon *ngIf="(onlinetest.candidate_comment || '').length > 0" [icon]="faExplanation" (click)="setExplanation(onlinetest)" [pTooltip]="t('explanations')"></fa-icon></span>
                        <p class="subinfo">
                          <span *ngIf="candidate.login_user">{{ t('labels.login') }}: {{ candidate.login_user }}<br></span>
                          <span *ngIf="candidate.login_password">{{ t('labels.password') }}: {{ candidate.login_password }}<br></span>
                          <span *ngIf="candidate.comment">{{ t('labels.comment') }}: {{ candidate.comment }}<br></span>
                        </p>
                      </ng-container>
                      <span *ngIf="candidate.status === 'finished' || candidate.status === 'result'">{{onlinetest.fullname}} <fa-icon [icon]="faCheck"></fa-icon></span>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </div>
            </div>
          </ng-container>
        </li>
      </ul>
      <ng-container *ngIf="showReloadButton() === true">
        <button *ngIf="loading !== true" class="p-button-sm p-mt-1" (click)="loadReports()" pButton type="button" icon="pi pi-chart-bar" label="{{ t('labels.get_reports') }}"></button>
        <button *ngIf="loading === true" class="p-button-sm p-mt-1" pButton type="button" label="{{ t('labels.get_reports') }}" icon="pi pi-spin pi-spinner" [disabled]="true"></button>
      </ng-container>
  </ng-container>
  </div>

  <p-dialog [(visible)]="explainedOnlinetestVisible" [header]="explainedOnlinetest?.fullname + ': ' + t('explanations')" [modal]="true" [closable]="false" [draggable]="false" [resizable]="false">
    <div [innerHTML]="explainedOnlinetest?.candidate_comment"></div>
    <ng-template pTemplate="footer">
      <button class="p-button-sm" (click)="setExplanation()" pButton type="button" icon="pi pi-check" label="{{ t('ok') }}"></button>
    </ng-template>
  </p-dialog>

</ng-container>
